import axios from 'axios';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueDatePicker from '@vuepic/vue-datepicker';

import App from './App.vue';
import router from './router';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.component('VueDatePicker', VueDatePicker);

axios.defaults.withCredentials = true;

app.mount('#app');
